import * as RadixSwitch from '@radix-ui/react-switch'
import * as React from 'react'

import { styled } from '~/styled'

const StyledSwitch = styled(RadixSwitch.Root, {
  base: [
    'appearance-none',
    'bg-grey-600',
    'border-none',
    'rounded-full',
    'cursor-pointer',
    'flex',
    'overflow-hidden',
    'relative',
    'transition-all',
    'duration-50',
    'ease-out',
    'hover:bg-grey-700',
    'focus:outline-2',
    'focus:outline-offset-1',
    'focus:outline-primary-800',
    'focus:outline-solid',
    'data-[state=checked]:bg-primary-800',
    'data-[state=checked]:hover:bg-primary-900',
    'disabled:cursor-not-allowed',
    'disabled:opacity-30'
  ],
  variants: {
    size: {
      md: ['p-0.5', 'w-10'],
      lg: ['p-1', 'w-16']
    }
  }
})

const StyledThumb = styled(RadixSwitch.Thumb, {
  base: [
    'bg-white',
    'rounded-full',
    'block',
    'transition-transform',
    'duration-50',
    'will-change-transform'
  ],
  variants: {
    size: {
      md: ['data-[state=checked]:translate-x-5', 'size-4'],
      lg: ['data-[state=checked]:translate-x-8', 'size-6']
    }
  }
})

type SwitchProps = React.ComponentProps<typeof StyledSwitch>

export const Switch = ({ size = 'md', ...rest }: SwitchProps) => (
  <StyledSwitch size={size} {...rest}>
    <StyledThumb size={size} />
  </StyledSwitch>
)

Switch.displayName = 'Switch'
